import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Button, CircularProgress, IconButton, Stack, Typography } from '@mui/material';
import { routes } from 'app/providers/router/routes';
import { CodeBlockWrapper, CodeTextField } from 'entities/connection';
import { coupleActions, coupleSelector } from 'entities/couple';
import { userSelector } from 'entities/user';
import { COLOR_WHITE } from 'shared/config';
import { useShallowSelector, useValidateInputField, ValidationTypes } from 'shared/hooks';
import { ArrowIcon, CopyTextField } from 'shared/ui/components';

import { useTranslation } from 'react-i18next';

import { ProposalBlock } from '../ui/ProposalBlock';
import {weddingSelector} from "../../../entities/wedding";
import {useEffect, useState} from "react";
import {Nullable} from "../../../shared/types";

export const FianceCodeContainer = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [ActiveState, setActiveState] = useState<boolean>(true);
  const [fiancePromoCode, handleChangeFiancePromoCode, setFiancePromoCode] = useValidateInputField({
    type: ValidationTypes.int,
  });

  const {
    partner: { promoCode: partnerPromoCode },
  } = useShallowSelector(coupleSelector.getCouple);
  const { promoCode } = useShallowSelector(userSelector.getUser);

  const handleMatch = () => {
    setActiveState(false);
    dispatch(coupleActions.addPartner({ promoCode: fiancePromoCode }));
    setFiancePromoCode('');
  };
  //useEffect(() => {
  //  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  //  let interval: any;
  //  if (state == 'init') {
  //    interval = setInterval(() => {
  //      let { state } = useShallowSelector(weddingSelector.getWedding);
  //      setActiveState(state)
  //    }, 1000);
  //  } else if (interval) {
  //    clearInterval(interval);
  //    interval = null;
  //  }
  //  return () => {
  //    clearInterval(interval);
  //  };
  //}, [state, dispatch]);

  const handleBack = () => {
    navigate(routes.connection.path);
  };

  return (
    <Stack sx={{display: 'flex', alignItems: 'center', padding: '0 30px'}}>
      <Stack maxWidth={550}>
        <Stack sx={{alignItems: 'center'}}>
          <Typography variant="h3" sx={{
            fontSize: '36px',
            fontWeight: '700',
            lineHeight: '0.95',
            textAlign: 'center',
            mt: { xs: 3, md: 0 },
            fontFamily: 'Montserrat, sans-serif'
          }} className="center">{t('fc_title')}</Typography>
          <Typography variant="h2"  sx={{
            marginTop: '12px',
            fontFamily: 'Tektur, serif',
            fontSize: {xs: '16px', md: '18px'},
            lineHeight: {xs: '1.25', md: '1.25'},
            fontWeight: '400',
            background: 'radial-gradient(circle, #2df6de 20%, #3c5dfe 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            textSlign: 'center',
            maxWidth: '500px',
            marginBottom: '20px !important'
          }}  className="center">{t('fc_description')}</Typography>
        </Stack>
        <IconButton size="small" color="info" onClick={handleBack}>
          <ArrowIcon />
        </IconButton>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={3} mt={{ xs: 4, md: 8 }} mb={1.5}>
          <CodeBlockWrapper>
            <Typography variant="body2" className="center" sx={{fontSize: '15px'}}>
              {t('connection_fiance_p1')}
            </Typography>
            <CopyTextField variant="code" text={promoCode} />
          </CodeBlockWrapper>
          <CodeBlockWrapper>
            <Typography variant="body2" className="center" sx={{fontSize: '15px'}}>
              {t('connection_fiance_p2')}
              {t('connection_fiance_p2_1')}
            </Typography>
            <CodeTextField
              inputValue={fiancePromoCode || partnerPromoCode}
              placeholder="00000"
              disabled={Boolean(partnerPromoCode)}
              onChange={handleChangeFiancePromoCode}
            />
          </CodeBlockWrapper>
        </Stack>
        {/*<ProposalBlock />*/}
        <Stack mt={3} spacing={3.5} alignItems="center">
          {partnerPromoCode && <Typography>Bringing hearts together</Typography>}
          <Button
            className={partnerPromoCode? 'active-bg-disabled' : 'disabled-opacity'}
            variant="contained"
            onClick={handleMatch}
            disabled={fiancePromoCode.length < 5 || !ActiveState}
            sx={{ width: 231 }}
          >
            {partnerPromoCode ? <CircularProgress size={30} sx={{ color: COLOR_WHITE }} /> : t('connection_fiance_next')}
          </Button>
        </Stack>
      </Stack>
    </Stack>
  );
};
